import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-skip-back-sharp",
  "use": "icon-play-skip-back-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-play-skip-back-sharp\"><title>Play Skip Back</title><path d=\"M143.47 64v163.52L416 64v384L143.47 284.48V448H96V64h47.47z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol